import { CheckCircle2, Play } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { Aula } from '@/types/masterclass';
import { getAulaProgress } from '@/hooks/useMasterClassProgress';
import { ScrollArea } from '@/components/ui/scroll-area';

interface MasterClassPlaylistProps {
  aulas: Aula[];
  currentAulaId: string | null;
  serieId: string;
  onSelect: (aulaId: string) => void;
}

export function MasterClassPlaylist({ aulas, currentAulaId, serieId, onSelect }: MasterClassPlaylistProps) {
  return (
    <ScrollArea className="h-full">
      <div className="p-4 space-y-1">
        {aulas.map((aula, index) => {
          const progress = getAulaProgress(aula.id, serieId);
          const isActive = aula.id === currentAulaId;
          
          return (
        <button
          key={aula.id}
          onClick={() => onSelect(aula.id)}
          className={cn(
            "mc-lessons__item w-full text-left p-3",
            isActive && "mc-lessons__item--active",
            !isActive && "hover:bg-gray-100"
          )}
        >
              <div className="flex items-center gap-3">
                {/* Número/Status */}
                <div className={cn(
                  "flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-medium transition-colors",
                  progress.status === 'concluida' 
                    ? "bg-green-100 text-green-700" 
                    : isActive 
                    ? "bg-white text-blue-600" 
                    : "bg-blue-50 text-blue-600"
                )}>
                  {progress.status === 'concluida' ? (
                    <CheckCircle2 className="h-4 w-4" />
                  ) : isActive ? (
                    <Play className="h-3 w-3" />
                  ) : (
                    index + 1
                  )}
                </div>
                
                {/* Título apenas - SEM TEMPO */}
                <div className="flex-1 min-w-0">
                  <h4 className={cn(
                    "font-medium text-sm line-clamp-2",
                    isActive ? "text-white" : "text-gray-900"
                  )}>
                    {aula.titulo}
                  </h4>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </ScrollArea>
  );
}
